export default __webpack_public_path__ + "static/media/preference.52cff7ef.svg";